module.exports = __webpack_public_path__ + "706cb5becb1171a8afdfecc749987a7a.png";